import { defineStore } from "pinia";

function emptyTrip() {
    localStorage.setItem("waiheke-trip", JSON.stringify([[]]));
}


function getStorage() {
    const value = localStorage.getItem("waiheke-trip")

    if (!value) {
        emptyTrip()
    }

    let storage = JSON.parse(value);

    if (storage === null) {
        emptyTrip();
    }

    if (!Array.isArray(storage) || !Array.isArray(storage[0])) {
        emptyTrip();
    }

    storage = JSON.parse(localStorage.getItem("waiheke-trip"));

    return storage;
}

export const useTripStore = defineStore("trip", {
    state: () => {
        return {
            value: getStorage(),
            data: [{ listings: [] }],
        };
    },
    actions: {
        emptyTrip,
        hasListings() {
            return this.value
                .map((day) => {
                    return day.length;
                })
                .filter((l) => l > 0).length > 0
                ? true
                : false;
        },
        encodeTrip() {
            return encodeURIComponent(JSON.stringify(this.value));
        },
        getTripQueryString() {
            return `?t=${this.encodeTrip()}`;
        },
        async getData() {
            // If there is no data don't make a request
            if (!this.hasListings()) {
                return;
            }

            let { origin, pathname } = window.location;

            if (pathname.slice(-1) !== "/") {
                pathname = `${pathname}/`;
            }

            const path =
                origin + pathname + "getTrip" + this.getTripQueryString();

            // @TODO this has no error handling
            fetch(path, {
                method: "get",
                headers: {
                    "Content-Type": "application/json",
                    "x-requested-with": "XMLHttpRequest",
                },
            })
                .then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                })
                .then((data) => {
                    this.data = data;
                });
        },
        add(id, data = null, day) {
            if (data === null) {
                console.warn("data required");
            }

            if (data) {
                const exists = this.data[day].listings.find((item) => {
                    return item.id === id;
                });
                if (!exists) {
                    this.data[day].listings.push(data);
                }
            }

            this.value = this.data.map((day) => {
                return day.listings.map((listing) => listing.id);
            });

            localStorage.setItem("waiheke-trip", JSON.stringify(this.value));
        },
        addDay() {
            this.data.push({ listings: [] });
        },
        remove(id, day) {

            if (typeof id !== "number") {
                throw "Id must be a number.";
            }

            const index = this.value[day].indexOf(id);

            if (index < 0) {
                return;
            }

            this.data[day].listings = this.data[day].listings.filter(
                (listing) => {
                    return listing.id != id;
                }
            );

            this.value[day] = this.data[day].listings.map(
                (listing) => listing.id
            );

            localStorage.setItem("waiheke-trip", JSON.stringify(this.value));
        },
        removeDay(day) {
            if (typeof day !== "number") {
                throw "Day must be an index in the trip array.";
            }

            // Prevent deleting the last day
            if (this.value.length === 1) {
                this.data[day].listings = [];
                this.value[day] = [];
                localStorage.setItem("waiheke-trip", JSON.stringify(this.value));
                return
            }

            if (this.data[day].listings.length === 0 || day !== 0) {
                this.data.splice(day, 1);
                this.value.splice(day, 1);
            } else {
                this.data[day].listings = [];
                this.value[day] = [];
            }

            localStorage.setItem("waiheke-trip", JSON.stringify(this.value));
        },
        merge(list) { },
        replace(list) { },
        replaceData(list, options = {}) {
            // @TODO validate input
            const defaults = {
                replaceStore: false,
                replaceURL: false,
            };

            for (const [key, value] of Object.entries(defaults)) {
                if (options[key] === undefined) {
                    options[key] = value;
                }
            }

            // Default behaviour is we swallow duplicates per day
            this.data = list.map((item) => {
                item.listings = item.listings.filter((value, index, self) => {
                    return (
                        index ===
                        self.findIndex((t) => {
                            return t.id === value.id;
                        })
                    );
                });
                return item;
            });

            this.value = this.data.map((day) => {
                return day.listings.map((listing) => listing.id);
            });

            if (options.replaceStore) {
                localStorage.setItem(
                    "waiheke-trip",
                    JSON.stringify(this.value)
                );
            }

            if (options.replaceURL) {
                // This isn't used just yet
                // console.log('Update URL here')
            }
        },
    },
});
